import { render, staticRenderFns } from "./statisticsCenter.vue?vue&type=template&id=75b9bf10&scoped=true"
import script from "./statisticsCenter.vue?vue&type=script&lang=js"
export * from "./statisticsCenter.vue?vue&type=script&lang=js"
import style0 from "./statisticsCenter.vue?vue&type=style&index=0&id=75b9bf10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b9bf10",
  null
  
)

export default component.exports